<template>
  <div v-show="resultEnum != null">
    <b-tooltip
      :label="resultEnum | resultText"
      :type="resultEnum | tooltipType"
    >
      <span class="icon" :class="resultEnum | textClass">
        <i class="fa-lg" :class="resultEnum | iconClass" />
      </span>
    </b-tooltip>
  </div>
</template>

<script>
import GameHelper from "@/utils/game-helper";
import { TOURNAMENT_GAME_RESULT } from "vue-chess-shared/constants";

export default {
  name: "GameResult",
  props: ["gameResult", "score", "result"],

  computed: {
    resultEnum() {
      if (this.result === "forfeit") {
        if (this.score == 0) return TOURNAMENT_GAME_RESULT.FORFEITL;
        if (this.score === 0.5) return TOURNAMENT_GAME_RESULT.FORFEITD;
        if (this.score === 1) return TOURNAMENT_GAME_RESULT.FORFEITW;
      }
      if (this.result === "disqualified" && this.score === 0) {
        return TOURNAMENT_GAME_RESULT.DISQUALIFIED;
      }
      if (this.result && this.result.includes("abort")) {
        return null;
      }
      if (!this.gameResult) {
        if (this.score == 0) return TOURNAMENT_GAME_RESULT.LOSS;
        if (this.score === 0.5) return TOURNAMENT_GAME_RESULT.DRAW;
        if (this.score === 1) return TOURNAMENT_GAME_RESULT.WIN;
      }
      return this.gameResult;
    },
  },

  filters: {
    resultText(resultEnum) {
      return GameHelper.tournamentResultText(resultEnum);
    },

    iconClass(resultEnum) {
      return [
        "far fa-circle",
        "fas fa-star",
        "fas fa-star-half-alt",
        "far fa-star",
        "far fa-times-circle",
        "far fa-star-half",
        "",
        "far fa-star",
        "far fa-times-circle",
        "far fa-star-half",
        "far fa-star",
        "fas fa-exclamation-triangle",
      ][resultEnum];
    },

    textClass(resultEnum) {
      return [
        "has-text-danger",
        "has-text-success",
        "has-text-warning",
        "has-text-success",
        "has-text-danger",
        "has-text-warning",
        "",
        "has-text-success",
        "has-text-danger",
        "has-text-warning",
        "has-text-success",
        "has-text-black",
      ][resultEnum];
    },

    tooltipType(resultEnum) {
      return [
        "is-danger",
        "is-success",
        "is-warning",
        "is-success",
        "is-danger",
        "is-warning",
        "is-primary",
        "is-success",
        "is-danger",
        "is-warning",
        "is-success",
        "is-black",
      ][resultEnum];
    },
  },
};
</script>

<style></style>
